<template>
  <base-layout v-if="ready">
    <div v-if="notFound === false">
      <v-row>
        <v-col>
          <vue-tel-input
            v-model="phone"
            mode="international"
            :preferred-countries="preferredCountries"
            @onInput="validateTel" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="member.firstName"
            label="First Name" />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="member.lastName"
            label="Last Name" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            v-model="member.email"
            label="Email" />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="member.cardId"
            label="Card Id" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4">
          <v-text-field
            v-model="member.birthDate"
            label="DOB"
            type="date" />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="member.gender"
            :items="genderItems"
            label="Gender" />
        </v-col>
        <v-col cols="4">
          <v-select
            v-model="member.type"
            :items="typeItems"
            label="Type" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="member.note"
            outlined
            label="Note" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
            outlined
            small
            @click="$router.go(-1)">
            Back
          </v-btn>
          <v-btn
            outlined
            small
            :disabled="!telInfo.isValid"
            color="primary"
            class="ml-4"
            @click="updateMember">
            Save
          </v-btn>
          <v-btn
            outlined
            small
            color="pink"
            class="ml-4"
            @click="confirmDelete">
            Delete
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <NotfoundPage
      v-else
      message="Member not found" />
  </base-layout>
</template>

<script>
import { mapActions } from 'vuex'
import NotfoundPage from '@/components/Notfound.vue'
import MemberProvider from '@/resources/MemberProvider'

const memberService = new MemberProvider()
export default {
  components: {
    NotfoundPage
  },
  data () {
    return {
      member: {},
      phone: '',
      notFound: false,
      telInfo: {},
      typeItems: ['normal', 'vip'],
      genderItems: ['N/A', 'male', 'female'],
      preferredCountries: ['TH', 'SG', 'MY', 'CN'],
      ready: false
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    }
  },
  mounted () {
    this.getMember()
  },
  methods: {
    ...mapActions({
      setLoading: 'Style/setLoading',
      setSnackbar: 'Style/setSnackbar',
      setModal: 'Style/setModal'
    }),
    validateTel ({ number, isValid, country }) {
      this.telInfo = {
        tel: number.e164,
        isValid,
        telInfo: {
          dialCode: country.dialCode,
          iso2: country.iso2,
          name: country.name
        }
      }
    },
    async updateMember () {
      await this.setLoading({
        active: true,
        clickAble: false,
        message: 'Updating member.'
      })
      try {
        this.member.tel = this.telInfo.tel
        this.member.telInfo = this.telInfo.telInfo
        await memberService.updateMember(this.member.id, this.member)
        this.setSnackbar({
          message: 'Success',
          type: 'success',
          timeout: 3000,
          canClose: true,
          value: true
        })
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 3000,
          canClose: true,
          value: true
        })
      } finally {
        await this.setLoading({
          active: false,
          clickAble: false,
          message: 'Getting member.'
        })
      }
    },
    async getMember () {
      try {
        this.notFound = false
        const { data } = await memberService.getMemberById(this.id)
        this.member = data
        this.phone = this.member.tel
        this.telInfo = {
          tel: this.member.tel,
          isValid: true,
          telInfo: this.member.telInfo
        }
      } catch (err) {
        this.notFound = true
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 5000,
          canClose: true,
          value: true
        })
      } finally {
        this.ready = true
      }
    },
    confirmDelete () {
      this.setModal({
        confirmText: 'Delete',
        cancelText: 'Cancel',
        message: `Delete Member id ${this.id}`,
        title: 'Confirm Delete',
        value: true,
        confirmOnly: false,
        confirmType: 'success',
        onConfirm: this.deleteMember,
        onCancel: null
      })
    },
    async deleteMember () {
      try {
        await memberService.deleteMember(this.id)
        this.setSnackbar({
          message: 'Delete Success!',
          type: 'success',
          timeout: 3000,
          canClose: true,
          value: true
        })
        this.$router.go(-1)
      } catch (err) {
        this.setSnackbar({
          message: err.message,
          type: 'pink',
          timeout: 5000,
          canClose: true,
          value: true
        })
      }
    }
  }
}
</script>
<style scoped>
.fade-in {
  transition:opacity 0.8s
}
</style>
